import { defineMessages } from 'react-intl';

const m = defineMessages({
  createActorWithAI: {
    id: 'CreateActorWithAI_createActorWithAI',
    defaultMessage: 'AI Actor Creation',
  },
  file: {
    id: 'CreateActorWithAI_file',
    defaultMessage: 'File',
  },
  dropFilesHere: {
    id: 'CreateActorWithAI_dropFilesHere',
    defaultMessage: 'Drop files here or click to browse',
  },
  supportsFileTypes: {
    id: 'CreateActorWithAI_supportsFileTypes',
    defaultMessage: 'Supports: PDF, PNG, JPEG',
  },
  text: {
    id: 'CreateActorWithAI_text',
    defaultMessage: 'Text',
  },
  textPlaceholder: {
    id: 'CreateActorWithAI_textPlaceholder',
    defaultMessage: 'Enter your text here...',
  },
  textHelper: {
    id: 'CreateActorWithAI_textHelper',
    defaultMessage: 'Enter text to extract context for actor creation',
  },
  formHelper: {
    id: 'CreateActorWithAI_formHelper',
    defaultMessage: 'Select the form type for actor creation',
  },
  formPlaceholder: {
    id: 'CreateActorWithAI_formPlaceholder',
    defaultMessage: 'Select form type',
  },
  selectForm: {
    id: 'CreateActorWithAI_selectForm',
    defaultMessage: 'Select Form',
  },
  actorName: {
    id: 'CreateActorWithAI_actorName',
    defaultMessage: 'Actor Name (Optional)',
  },
  actorNamePlaceholder: {
    id: 'CreateActorWithAI_actorNamePlaceholder',
    defaultMessage: 'Enter actor name (optional)',
  },
  actorNameHelper: {
    id: 'CreateActorWithAI_actorNameHelper',
    defaultMessage:
      'Enter a name for the actor or leave blank for auto-generation',
  },
  createActor: {
    id: 'CreateActorWithAI_createActor',
    defaultMessage: 'Create Actor',
  },
  noFormSelected: {
    id: 'CreateActorWithAI_noFormSelected',
    defaultMessage: 'Please select a form',
  },
  noTextNorFiles: {
    id: 'CreateActorWithAI_noTextNorFiles',
    defaultMessage: 'Please enter text or attach a file',
  },
});

export default m;
